import { respondTo } from "@/respondTo";
import Styled from "styled-components";

export const MainContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;
    padding: 2.5rem 1.25rem;

    ${respondTo.desktop`
        flex-direction: row;
        justify-content: space-between;
        padding: 2.5rem;
    `}

    ${respondTo.desktop_xl`
        padding: 4.375rem;
    `}
    `;

export const TitleBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    h2 {
        color: var(--on-background-light);
    }

    ${respondTo.desktop`
        width: 50%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        text-align: left;
        height: 100%;

        h1 {
            padding: 0 12rem 0 0;
        }
        
    `}
    `;

export const InfoContainer = Styled.div`
display:none;

    ${respondTo.desktop`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex
        ga-start;
        text-align: left;
        gap: 1.25rem;
        padding: 2.5rem 0 0 0;
        width: 100%;
        
    `}
    `;

export const InnerContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;
    color: var(--on-primary-container-light); 

    ${respondTo.desktop`
        width: 50%;
        gap: 2rem;
        align-items: flex-start;
        `}
    `;
export const FormContainer = Styled.form<{ onSubmit?: any }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;

 
    `;

export const FormBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;
 

    ${respondTo.tablet_landscape_s`
   flex-wrap: wrap;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   row-gap : 1rem;
   column-gap: 0.625rem;
   height: 100%;
   width: 100%; 
    `}

    ${respondTo.desktop`
       row-gap : 1.5rem;
       column-gap: 1.25rem;
       padding: 0 0 2rem;
    `}
    `;

export const CheckBox = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 0.5rem;
    text-align: left;
    padding-bottom: 1.875rem;
    color: var(--on-background-light);

    ${respondTo.tablet_landscape_s`
    padding-bottom: 0.625rem;
    `}

    ${respondTo.desktop`
       padding-bottom: 1.25rem;
    `}

    `;

export const sxBtn = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "1.25rem",
  "@media (min-width: 1024px)": {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
};

export const FooterContainer = Styled.div`
    display:  flex
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 1.25rem;
    color: var(--on-primary-dark);

    ${respondTo.desktop`
        display: none;
    `}
    `;

export const CellectInfoContainer = Styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    column-gap: 0.5rem;
    color: var(--on-background-light);
    `;

export const formWidth = {
  "& .MuiFilledInput-root": {
    backgroundColor: "#e2e4e9 !important",
  },
  width: "100%",
  "@media (min-width: 1024px)": {
    width: "48%",
  },
};

export const messageBgColor = {
  "& .MuiFilledInput-root": {
    backgroundColor: "#e2e4e9 !important",
  },
};
